// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"0e30d39e","581":"5ba0e94f"}[chunkId] + ".chunk.css";
};